import React, { useState } from 'react';
import { Button, Typography } from '@mui/material';
import { Modal, Accordion } from 'react-bootstrap';
import UpdateForm from './UpdateForm';

export default function CompanyLocation() {

  const [lgShow, setLgShow] = useState(false);


  return (
    <>

      <div className="row">

        <div className="row my-3 ">
          <div className="col-md-6">
            <Typography className="mx-3" variant='h4' sx={{ pb: 3 }}>
            Account Location
            </Typography>
          </div>
          <div className="col-md-6 d-flex justify-content-end"   >

            <button type="button" className="btn btn-danger" onClick={() => setLgShow(true)} style={{ height: "40px" }}>Help</button>
            <Modal
              size="lg"
              show={lgShow}
              onHide={() => setLgShow(false)}
              aria-labelledby="example-modal-sizes-title-lg"

            >

              <Modal.Header closeButton style={{ color: '#FFFFFF', backgroundColor: '#C62828' }}>
                <Modal.Title id="example-modal-sizes-title-lg" >
                  Instructions to Add/Edit Account Locations
                </Modal.Title>
              </Modal.Header>
              <Modal.Body style={{ backgroundColor: '#F8FAFC', padding: '24px' }}>
                <style>{`
                  .help-badge {
                    padding: 4px 10px;
                    border-radius: 16px;
                    font-weight: 700;
                    font-size: 12px;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                    margin-right: 10px;
                  }
                  .badge-create   { background: #e6fffa; color: #234e52; border: 1px solid #b2f5ea; }
                  .badge-update   { background: #fffaf0; color: #9c4221; border: 1px solid #feebc8; }
                  .badge-delete   { background: #fff5f5; color: #9b2c2c; border: 1px solid #fed7d7; }
                  .badge-inactive { background: #f1f5f9; color: #475569; border: 1px solid #cbd5e1; }
                  
                  .help-card-text {
                    font-size: 14px;
                    color: #4a5568;
                    line-height: 1.5;
                    margin-bottom: 16px;
                  }
                  .video-responsive-wrapper {
                    position: relative;
                    width: 100%;
                    padding-top: 56.25%; /* 16:9 Aspect Ratio */
                    border-radius: 8px;
                    overflow: hidden;
                    background: #000000;
                  }
                  .video-responsive-wrapper video {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                  }
                  .accordion-button:not(.collapsed) {
                    background-color: #f1f5f9;
                    color: #1e293b;
                  }
                `}</style>

                <Accordion defaultActiveKey="0" flush>

                  {/* 1. CREATE LOCATION */}
                  <Accordion.Item eventKey="0" className="mb-2 border rounded">
                    <Accordion.Header>
                      <span className="help-badge badge-create">Create</span>
                      <strong>How to Create an Account Location</strong>
                    </Accordion.Header>
                    <Accordion.Body>
                      <p className="help-card-text">
                        Select the account name from the dropdown to display the <strong>Maximum Number of Locations Allowed</strong> field. Click on <strong>Add New Location</strong>, fill in the Location Name, Country, State, City, and Location Type, and click <strong>Submit</strong>. The new location will be added successfully, and a Location ID will be generated automatically based on the company ID and branch name.
                        <br /><br />
                        <em>Note: The Company ID and Maximum Number of Locations Allowed fields are non-editable. If the maximum location limit has been reached, a new location cannot be created, and a pop-up prompt will display: "You've exceeded the maximum allowed locations you can add."</em>
                      </p>
                      <div className="video-responsive-wrapper">
                        <video controls preload="metadata" playsInline>
                          <source src="https://d1efa1i7wh44gq.cloudfront.net/Account location - create.mp4" type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>

                  {/* 2. UPDATE LOCATION */}
                  <Accordion.Item eventKey="1" className="mb-2 border rounded">
                    <Accordion.Header>
                      <span className="help-badge badge-update">Update</span>
                      <strong>How to View or Edit an Account Location</strong>
                    </Accordion.Header>
                    <Accordion.Body>
                      <p className="help-card-text">
                        Navigate to Account Location and select the required account name from the dropdown. The existing location details will display automatically, allowing you to view or edit details as required. Click the <strong>Submit</strong> button to save changes. To activate or deactivate a location, select the required location and choose Activate or Deactivate from the dropdown.
                      </p>
                      <div className="video-responsive-wrapper">
                        <video controls preload="metadata" playsInline>
                          <source src="https://d1efa1i7wh44gq.cloudfront.net/Account location - edit.mp4" type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>

                  {/* 3. DELETE LOCATION */}
                  <Accordion.Item eventKey="2" className="mb-2 border rounded">
                    <Accordion.Header>
                      <span className="help-badge badge-delete">Delete</span>
                      <strong>How to Delete an Account Location</strong>
                    </Accordion.Header>
                    <Accordion.Body>
                      <p className="help-card-text">
                        Select the required account, then click the <strong>Delete icon</strong> for the desired location in the table. A confirmation pop-up will display indicating that the account location will be permanently deleted. Confirm the action to complete permanent deletion.
                      </p>
                      <div className="video-responsive-wrapper">
                        <video controls preload="metadata" playsInline>
                          <source src="https://d1efa1i7wh44gq.cloudfront.net/Account location - delete.mp4" type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>

                  {/* 4. INACTIVE LOCATION */}
                  <Accordion.Item eventKey="3" className="mb-2 border rounded">
                    <Accordion.Header>
                      <span className="help-badge badge-inactive">Inactive</span>
                      <strong>How to Inactivate an Account Location</strong>
                    </Accordion.Header>
                    <Accordion.Body>
                      <p className="help-card-text">
                        Select the vendor to display the list of locations. Hover over the row of the target location, navigate to the <strong>Location Status</strong> column dropdown, and change the status to <strong>Inactive</strong>. Confirm the action on the resulting pop-up prompt.
                      </p>
                      <div className="video-responsive-wrapper">
                        <video controls preload="metadata" playsInline>
                          <source src="https://d1efa1i7wh44gq.cloudfront.net/Account location - inactive.mp4" type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>

                </Accordion>
              </Modal.Body>
            </Modal>

          </div>
        </div>

        <div className="row">
          <div className="col-8 justify-content-end px-4">

          </div>
        </div>
        {/* <div className="col-4 d-flex justify-content-end px-5">
        
          
         
        </div> */}

      </div>


      <UpdateForm />



    </>
  );
}
